import { render, staticRenderFns } from "./SectionTitle2.vue?vue&type=template&id=288a3140"
import script from "./SectionTitle2.vue?vue&type=script&lang=js"
export * from "./SectionTitle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports